module.exports = __webpack_public_path__ + "media/images/dividend/img-quote-c3752000143ec5e1cfb92a5a6c5b634e.svg";